module.exports = __webpack_public_path__ + "img/cramera_des_2.e7fdaf91.jpg";